import { IGetAllTreinamentosForTreinamentosCargosUseCase } from "../../../presentation/useCases/read/get_all_treinamentos_for_treinamentos_cargos_use_case";
import { TreinamentoTreinamentoCargo } from "../../models/treinamento_treinamento_cargo";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * GetAllTreinamentosForTreinamentosCargosUseCase
 */

export class GetAllTreinamentosForTreinamentosCargosUseCase implements IGetAllTreinamentosForTreinamentosCargosUseCase {
  constructor(private readonly repository: IRhRepository) { }

  async getAllTreinamentos(): Promise<TreinamentoTreinamentoCargo[]> {
    return await this.repository.getAllTreinamentoTreinamentoCargo();
  }
}
